module.exports = __webpack_public_path__ + "static/media/bmx-skatepark.92eae31b.mov";